import { takeEvery } from 'redux-saga/effects';
import { track, identify } from './track';

export function* trackSaga() {
  yield takeEvery('TRACK', track);
}

export function* identifySaga() {
  yield takeEvery('IDENTIFY', identify);
}
